import { DataBean } from "../DataBean";

export class QualityGarmentProperties extends DataBean {
  public async getQualityGarmentPropertiesCatalogPorPropiedades(
    properties: any,
    maxRows: number
  ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityGarmentPropertiesCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getQualityGarmentPropertiesRender(
    page: number,
    rows: number,
    properties: any,
  ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getQualityGarmentPropertiesRender_Number_Number_java.util.Map",
      [page, rows,properties]
    );
  }

  public async getMeasurementUnitCatalog(
    page: number,
    recordsPerPage: number
  ): Promise<any> {
    return this.getCustomService(
      "FinanceCore",
      "com.advantage.shared.Report_getMeasurementUnitCatalog_Number_Number",
      [page, recordsPerPage]
    );
  }

  public async deleteQualityGarmentProperties(
    idqualitygarmentproperties: number
  ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "boolean_deleteQualityGarmentProperties_Number",
      [idqualitygarmentproperties]
    );
  }

  public async updateQualityGarmentProperties(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityGarmentProperties_updateQualityGarmentProperties_com.orange.finance.processcontract.bean.QualityGarmentProperties",
      [
        {
          DataBeanProperties: bean,
          DataBeanName:
            "com.orange.finance.processcontract.bean.QualityGarmentProperties",
        },
      ]
    );
  }
}
